import { logger } from "@justhome/common";
import { fetchGetAssumptionsWithLogging } from "@lib/api-wrappers";
import { ApplicationFormValues } from "@lib/mapApplicationData/types";

export const validateDateInput = (value: string, maxYears: number) => {
  const getDate = (val: number | string | Date) => {
    const date = new Date(val);
    date.setHours(3);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  };

  const minDate = getDate(new Date());
  const valueDate = getDate(value);
  const maxDate = getDate(new Date());
  maxDate.setFullYear(maxDate.getFullYear() + maxYears);

  if (valueDate.getTime() < minDate.getTime()) {
    return false;
  } else if (valueDate.getTime() > maxDate.getTime()) {
    return false;
  }
  return true;
};

export const isValidNumber = (value: string): boolean => {
  const valueAsNumber = Number(value);
  return !isNaN(valueAsNumber) && valueAsNumber > 0;
};

export const getMinMaxDateInput = (maxYears?: number) => {
  const date = new Date(new Date());
  const year = date.getFullYear();
  const month = new Date().getMonth() + 1;
  const day = date.getDate();
  return `${maxYears ? year + maxYears : year}-${
    month < 10 ? "0" : ""
  }${month}-${day < 10 ? "0" : ""}${day}`;
};

export const validateZip = async (value: string) => {
  try {
    const isNumber = !!Number(value);
    if (isNumber) {
      const assumptions = await fetchGetAssumptionsWithLogging({
        queryParams: {
          zipCode: value,
        },
      });
      return !!assumptions?.zipCode;
    } else {
      return false;
    }
  } catch (e) {
    const error = e as Error;
    // if code === 404 => false, else other error code => true
    return !error?.message?.includes("response code 404");
  }
};

export const getRealEstateAgentCommissionDefaultValue = async (
  data: ApplicationFormValues,
) => {
  try {
    if (!data) {
      return;
    }
    const assumptions = await fetchGetAssumptionsWithLogging({
      queryParams: {
        zipCode: data.postalCode,
      },
    });

    const realEstateAgentFeePercentage =
      assumptions.realEstateAgentFeePercentage;

    if (!realEstateAgentFeePercentage) {
      return;
    }
    return realEstateAgentFeePercentage;
  } catch (error) {
    logger.error(
      `Error in ${getRealEstateAgentCommissionDefaultValue.name} function.`,
      error,
    );
  }
};
